import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKanbanView: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="kanban-view, columns"><path d="M5 4C3.34315 4 2 5.34314 2 7V12.8571C2 14.514 3.34315 15.8571 5 15.8571C6.65685 15.8571 8 14.514 8 12.8571V7C8 5.34315 6.65685 4 5 4Z" fill="currentColor"/><path d="M12 4C10.3431 4 9 5.34315 9 7V17C9 18.6569 10.3431 20 12 20C13.6569 20 15 18.6569 15 17V7C15 5.34315 13.6569 4 12 4Z" fill="currentColor"/><path d="M19 4C17.3431 4 16 5.34314 16 7V10.7857C16 12.4426 17.3431 13.7857 19 13.7857C20.6569 13.7857 22 12.4426 22 10.7857V7C22 5.34315 20.6569 4 19 4Z" fill="currentColor"/></CentralIconBase>;
};

export default IconKanbanView;
